import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "value", "onChange", "inputMode", "valueIsNumericString", "onValueChange"];
import { TextField } from '@material-ui/core';
import { forwardRef } from 'react';
import { PatternFormat } from 'react-number-format';
import { useUID } from "../utils/useUID.js";
import { jsx as _jsx } from "react/jsx-runtime";
export var PatternField = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      id,
      value,
      onChange,
      inputMode = 'decimal',
      valueIsNumericString = true,
      onValueChange: _onValueChange
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var uid = useUID(id);
  return /*#__PURE__*/_jsx(PatternFormat, _objectSpread(_objectSpread({}, props), {}, {
    id: uid,
    value: value !== null && value !== void 0 ? value : ''
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    ,
    inputMode: inputMode,
    getInputRef: ref,
    valueIsNumericString: valueIsNumericString,
    customInput: TextField,
    onValueChange: (values, sourceInfo) => {
      var {
        event
      } = sourceInfo;
      onChange === null || onChange === void 0 ? void 0 : onChange(_objectSpread(_objectSpread({}, event), {}, {
        target: _objectSpread(_objectSpread({}, event === null || event === void 0 ? void 0 : event.target), {}, {
          value: values.value
        })
      }));
      _onValueChange === null || _onValueChange === void 0 ? void 0 : _onValueChange(values, sourceInfo);
    }
  }));
});
if (process.env.NODE_ENV !== "production") PatternField.displayName = "PatternField";
PatternField.displayName = 'PatternField';